import api from '@/services';

export const apiFetchClients = async() => {
  return await api.get('/app/clients')
}
